<template>
  <el-dialog title="Change password" :visible.sync="isShowChangePasswordForm"
    :closeOnClickModal="false"
    class="medium register-dialog"
    @open="onOpen"
    :custom-class="loading ? 'loading' : ''"
    @submit.prevent.native="changePassword">
    <el-form :model="form">
      <el-form-item :label="$t('TEXT_OLD_PASSWORD')" :label-width="formLabelWidth">
        <el-input v-model="form.oldPassword" autocomplete="off" type="password"></el-input>
      </el-form-item>
      <el-form-item :label="$t('TEXT_NEW_PASSWORD')" :label-width="formLabelWidth">
        <el-input v-model="form.newPassword" autocomplete="off" type="password"></el-input>
      </el-form-item>
      <el-form-item :label="$t('TEXT_CONFIRM_PASSWORD')" :label-width="formLabelWidth">
        <el-input v-model="form.confirmPassword" autocomplete="off" type="password"
         @keyup.enter.native="changePassword()"></el-input>
      </el-form-item>
    </el-form>
    <span slot="footer" class="dialog-footer">
      <el-button type="primary" @click="changePassword" :disabled="!isValidated" class="btn btn-primary"
       >{{ $t('BTN_CHANGE_PASSWORD') }}</el-button>
    </span>
  </el-dialog>
</template>

<script>
export default {
  data () {
    return {
      loading: false,
      form: {
        oldPassword: '',
        newPassword: '',
        confirmPassword: ''
      },
      formLabelWidth: '120px'
    }
  },
  computed: {
    isShowChangePasswordForm: {
      get () {
        return this.$store.getters.isShowChangePasswordForm
      },
      set (val) {
        this.$store.dispatch('toggleChangePasswordFormModal')
        this.$store.dispatch('closeAllModal')
      }
    },
    configs () {
      return this.$store.getters.configs
    },
    isValidated () {
      return this.form.oldPassword && this.form.newPassword && this.form.confirmPassword &&
        this.form.newPassword === this.form.confirmPassword
    },
    account () {
      return this.$store.getters.account
    }
  },
  methods: {
    toggleModal () {
      this.$store.dispatch('toggleChangePasswordFormModal')
      this.$store.dispatch('closeAllModal')
    },
    onOpen () {
      this.form.address = this.account.address
      const ref = this.$route.query.ref
      ref && (this.form.refAddress = ref)
    },
    changePassword () {
      if (!this.isValidated) return
      this.loading = true
      this.$store.dispatch('changePassword', this.form).then(status => {
        this.loading = false
        if (status) {
          this.$store.dispatch('toggleChangePasswordFormModal')
          this.$store.dispatch('closeAllModal')
        }
      })
    }
  }
}
</script>
